import { createGlobalState } from "react-hooks-global-state"

const { useGlobalState } = createGlobalState({
    isAnyModalOpen: false,
    title: null,
    project: null
})

export default useGlobalState